module.exports = __webpack_public_path__ + "static/7-7fe0916a15dfef848f2cab3474564aab.jpg";